import React, { useState } from 'react'
import { Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import useStyles from './useStyles'
import { SearchCuit } from '../SearchCuit/SearchCuit'

export const Home = () => {
  const classes = useStyles()
  const [valueFilter, setValueFilter] = useState(null)

  return (
    <div className={classes.root}>
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Instancias de la aplicación Mi Estudio
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá visualizar las instancias de la aplicación Mi
          Estudio asociadas a una organización o CUIT.
        </Typography>
      </div>
      <SearchCuit valueFilter={valueFilter} setValueFilter={setValueFilter} />
    </div>
  )
}
